import React from 'react';
import { Button } from 'primereact/button';

const TestStyles = () => {
    return (
        <div className="p-8">
            <h1 className="text-3xl font-bold text-blue-600 mb-4">CSS Test Page</h1>
            
            {/* Tailwind CSS Test */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Tailwind CSS Test</h2>
                <div className="flex gap-4">
                    <div className="bg-red-500 text-white p-4 rounded">Red Box</div>
                    <div className="bg-green-500 text-white p-4 rounded">Green Box</div>
                    <div className="bg-blue-500 text-white p-4 rounded">Blue Box</div>
                </div>
            </div>

            {/* PrimeReact Test */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">PrimeReact Test</h2>
                <div className="flex gap-2">
                    <Button label="Primary" />
                    <Button label="Secondary" severity="secondary" />
                    <Button label="Success" severity="success" />
                    <Button label="Warning" severity="warning" />
                    <Button label="Danger" severity="danger" />
                </div>
            </div>

            {/* Custom CSS Test */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Custom CSS Test</h2>
                <div className="hover-shadow-4 p-4 border rounded transition-all">
                    Hover over me for shadow effect
                </div>
            </div>

            {/* Loading Indicator Test */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold mb-2">Loading Animation Test</h2>
                <div className="loading-indicator"></div>
            </div>
        </div>
    );
};

export default TestStyles;